export function removeWhitespace(stringWithWhitespace: string | null): string {
  return stringWithWhitespace ? stringWithWhitespace.replaceAll(/\s/g, '') : '';
}

export const formatToTitleCase = (input: string): string => {
  const stringWithSpaces = input.replace(/_/g, ' ');

  return stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1).toLowerCase();
};
